import { useExplorer } from "@/context/ExplorerContext";
import { ImageSlot } from "@/components/lurio/ImageSlot";
import { Eyebrow, Section, CTA, Fr } from "@/components/lurio/Primitives";
import { Reveal, Stamp } from "@/components/lurio/Motion";

const Station = ({ b, i, t }) => (
  <div className="relative flex flex-col items-center pt-8 text-center">
    <Stamp delay={i * 0.08} className="absolute -top-1 start-1/2 z-10 -translate-x-1/2 rtl:translate-x-1/2">
      <div data-testid={`badge-${b.id}`} className="sticker peel h-24 w-24 overflow-hidden rounded-full bg-cream-card p-1 sm:h-28 sm:w-28" style={{ transform: `rotate(${i % 2 ? 4 : -4}deg)` }}>
        <ImageSlot id={`badge_${b.id}`} rounded="rounded-full" className="h-full w-full" />
      </div>
    </Stamp>
    <div className="w-full rounded-book bg-cream-card p-2 pt-16 shadow-[0_18px_40px_-24px_rgba(30,42,56,0.45)]" style={{ transform: `rotate(${i % 2 ? 1.2 : -1.2}deg)` }}>
      <ImageSlot id={`world_${b.id}`} rounded="rounded-[12px]" />
    </div>
    <span className="mt-5 text-xs font-bold text-ink-soft">{t.badges.worldLabel} {b.n}</span>
    <Fr className="mt-0.5 text-[0.85rem] font-semibold text-ink/80">{b.world}</Fr>
    <Fr className="mt-2 text-lg font-semibold leading-tight text-blue">{b.name}</Fr>
    <span className="mt-1 text-xs font-bold text-coral">{b.missions} {t.badges.missionsLabel}</span>
    <span className="mt-1 text-sm text-ink-soft">{b.skill}</span>
  </div>
);

export default function Badges() {
  const { t } = useExplorer();
  const [before, after] = t.badges.body.split("Diplôme d'Explorateur");
  return (
    <Section id="badges" bg="bg-cream-deep" className="grain overflow-hidden !pt-14 sm:!pt-20">
      <div className="max-w-2xl">
        <Reveal><Eyebrow className="mb-4">{t.badges.eyebrow}</Eyebrow></Reveal>
        <Reveal delay={0.05}><h2 className="font-serif text-4xl font-bold leading-[1.3] sm:leading-[1.3] lg:leading-[1.3] text-ink sm:text-5xl">{t.badges.title}</h2></Reveal>
        <Reveal delay={0.1}>
          <p className="mt-5 text-[1.08rem] leading-[1.85] text-ink-soft sm:text-lg">
            {before}<Fr className="font-semibold text-ink">Diplôme d'Explorateur</Fr>{after}
          </p>
        </Reveal>
      </div>
      <div className="relative mt-14">
        <svg aria-hidden className="pointer-events-none absolute inset-x-0 top-10 hidden h-10 w-full lg:block" viewBox="0 0 1000 40" preserveAspectRatio="none">
          <path d="M20 20 C 150 -10, 250 50, 400 20 S 650 -10, 800 20 S 950 40, 985 20" fill="none" stroke="#1E2A38" strokeWidth="2" strokeDasharray="6 8" opacity=".35" />
        </svg>
        <ol data-testid="badge-path" className="-mx-5 flex snap-x snap-mandatory gap-5 overflow-x-auto px-5 pb-4 sm:-mx-8 sm:px-8 lg:mx-0 lg:grid lg:grid-cols-5 lg:gap-5 lg:overflow-visible lg:px-0" style={{ scrollbarWidth: "none" }}>
          {t.badges.items.map((b, i) => (
            <li key={b.id} className="w-[64vw] shrink-0 snap-center sm:w-[38vw] lg:w-auto">
              <Station b={b} i={i} t={t} />
            </li>
          ))}
        </ol>
      </div>
      <Reveal className="mt-12 flex justify-center lg:justify-start">
        <CTA testId="badges-cta-button" />
      </Reveal>
    </Section>
  );
}
